import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { gql, useMutation, useQuery } from '@apollo/client';
import { connect } from 'react-redux';

const GET_USER_INFORMATION = gql`
  query UserInformation($token: String!, $username: String!) {
    userInformation(
      input: {
        token: $token
        username: $username
      }
    ) {
      profile_settings {
        let_follow_me
      }
      follow
    }
  }
`;

const FOLLOW_USER = gql`
  mutation FollowUser($token: String!, $username: String!){
    followUser(
      input: {
        token: $token
        username: $username
      }
    ) {
      status
      message
    }
  }
`;

const UNFOLLOW_USER = gql`
  mutation UnfollowUser($token: String!, $username: String!){
    unfollowUser(
      input: {
        token: $token
        username: $username
      }
    ) {
      status
      message
    }
  }
`;

const FollowUser = (props) => {
  const { token, username } = props;

  const [isFollowingAllowed, setFollowingAllowed] = useState(false);
  const [isFollowed, setFollowed] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(null);
      }, 5000);
    }
  }, [successMessage]);

  useQuery(GET_USER_INFORMATION, {
    variables: { token, username },
    fetchPolicy: 'cache-first',
    onCompleted: (d) => {
      setFollowingAllowed(d.userInformation.profile_settings.let_follow_me);
      setFollowed(d.userInformation.follow);
    },
  });

  const [followUser] = useMutation(FOLLOW_USER, {
    onCompleted: () => setFollowed(true),
  });

  const [unfollowUser] = useMutation(UNFOLLOW_USER, {
    onCompleted: () => setFollowed(false),
  });

  const onFollow = () => {
    followUser({ variables: { token, username } }).then(() => {
      setSuccessMessage(`You are now following ${username}`);
    });
  };

  const onUnfollow = () => {
    unfollowUser({ variables: { token, username } }).then(() => {
      setSuccessMessage(`You have unfollowed ${username}`);
    });
  };

  if (!isFollowingAllowed) {
    return null;
  }

  return (
    <Fragment>
      {isFollowed ? (
        <div className="header-button" onClick={onUnfollow}>
          Unfollow User
        </div>
        ) : (
          <div className="header-button" onClick={onFollow}>
            Follow User
          </div>
      )}

      <div
        className="alert alert-success alert-dismissible fade show"
        role="alert"
        style={{
          display: successMessage ? 'block' : 'none',
          position: 'fixed',
          bottom: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <strong>Success!</strong> {successMessage}
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
          onClick={() => setSuccessMessage('')}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </Fragment>
  );
};

FollowUser.propTypes = {
  token: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    token: state.auth.commentToken,
  };
};

export default connect(mapStateToProps)(FollowUser);

